import React from 'react';
import { Field, reduxForm } from 'redux-form';
import Row from '../../../shared/components/Row';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import FormField from '../../../shared/components/FormField';
import LinkButton from '../../../shared/components/LinkButton';
import PropTypes from 'prop-types';
import OutsourceTreeDetail from '../../../works/components/OutsourceTreeDetail';
import { PsRoutes } from '../../../shared/routing/Routes';

class WorkDetail extends React.Component {

    render() {
        const {
            contracts,
            handleSubmit,
        } = this.props;

        return (
            <form onSubmit={handleSubmit(this.submit)}>
                <Row>
                    <div className="col-md-6">
                        <Row>
                            <Field
                                label={I18nUtils.tr('TR_CODIGO') + ':'}
                                placeholder={I18nUtils.tr('TR_CODIGO')}
                                name="code"
                                type="text"
                                colWidth="col-sm-3"
                                component={this.renderField}
                                disabled={true}
                            />
                            <Field
                                label={I18nUtils.tr('TR_ESTADO')}
                                labelDisabled={I18nUtils.tr('TR_INACTIVA')}
                                labelEnabled={I18nUtils.tr('TR_ACTIVA')}
                                defaultChecked={true}
                                name="isActive"
                                checked={true}
                                type={'checkbox'}
                                colWidth="col-sm-4"
                                component={this.renderField}
                                disabled={true}
                            />
                        </Row>
                        <Row>
                            <Field
                                label={I18nUtils.tr('TR_NOMBRE') + ':'}
                                placeholder={I18nUtils.tr('TR_NOMBRE_DE_LA_OBRA')}
                                name="name"
                                type="text"
                                colWidth="col-sm-6"
                                component={this.renderField}
                                disabled={true}
                            />
                        </Row>
                        <Row>
                            <Field
                                label={I18nUtils.tr('TR_FECHA_INICIO')}
                                placeholder={I18nUtils.tr('TR_FECHA_INICIO')}
                                name="startDate"
                                type={'date'}
                                colWidth="col-sm-6"
                                component={this.renderField}
                                disabled={true}
                            />
                            <Field
                                label={I18nUtils.tr('TR_FECHA_FIN')}
                                placeholder={I18nUtils.tr('TR_FECHA_FIN')}
                                name="endDate"
                                type={'date'}
                                colWidth="col-sm-6"
                                component={this.renderField}
                                disabled={true}
                            />
                        </Row>
                        <Row>
                            <Field
                                label={I18nUtils.tr('TR_DESCRIPCION_DE_LA_OBRA')}
                                placeholder=""
                                name="notes"
                                type={'textarea'}
                                rows={2}
                                colWidth="col-sm-12"
                                component={this.renderField}
                                disabled={true}
                            />
                        </Row>
                    </div>
                    <div className="col-md-6">
                        <OutsourceTreeDetail contracts={contracts}/>
                    </div>
                </Row>
                <Row>
                    <div className={'col-md-6'}>
                        <LinkButton
                            to={PsRoutes.MY_CONTRACTORS_WORKS}
                            text={I18nUtils.tr('TR_TODAS_LAS_OBRAS').toUpperCase()}
                            className={'btn-lg btn-block form-btn'}
                        />
                    </div>
                    <div className={'col-md-6'}/>
                </Row>
            </form>
        );
    }

    submit = () => {};

    renderField = (field) => <FormField field={field}/>;
}

export const WorkDetailForm = reduxForm({
    form: 'ContractorWorkDetailForm',
})(WorkDetail);

WorkDetailForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    contracts: PropTypes.array.isRequired,
};

WorkDetailForm.defaultProps = {
    initialValues: {},
    contracts: [],
};



// WEBPACK FOOTER //
// ./src/app/my-contractors/work/detail/WorkDetailForm.jsx